import { Base } from './_base.model';

export class StaffShadow extends Base {
  id: number;
  staff_id: string;
  company_id: string;
  bureau_id: string;
  shadow_id: string;
}
